var map = {
	"./academy-local.js": 84,
	"./academy-preprod.js": 85,
	"./academy-prod.js": 86,
	"./dev-v2.js": 88,
	"./dev.js": 87,
	"./index.js": 9,
	"./local.js": 89,
	"./preprod.js": 90,
	"./prod.js": 91
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 234;